import {getElementOffset,getPageOffset,windowSizes} from '../libs/sizes';

/**
 * element attributes:
 * data-tooltip-position="top|bottom"
 * data-tooltip-fixed="true|false" always show, no fade
 * data-tooltip-inline="true|false"
 * data-tooltip-outline="true|false" tooltip always points on element border (top or bottom) instead of mouse position.
 *
 * @param context
 */

export default context => {
    window.tooltipTi = -1;
    window.tooltipDelay = 200;
    const windowSize = windowSizes();
    const setTooltips = function () {
        $("[data-tooltip]", context).each((i, elem) => {
            $(elem).setTooltip();
        });
    }

    const closeTooltip = function () {
        $(".tooltip").not(".tooltip[data-fixed]").remove();
    };

    const openTooltip = function (elem, mx, my, isFixed, isInline) {
        closeTooltip();
        var str = elem.data("tooltip");
        var offset = getElementOffset(elem)
        var pOffset = getPageOffset()
        var style = "";
        var xp = 0, yp = 0;
        var hpos = "center";
        var vpos = "bottom";
        const buffer = 50;
        if (isFixed) {
            hpos = "";
            vpos = "";
        } else if (isInline) {
            var pos = {
                l: "50%",
                r: null,
                t: null,
                b: "100%",
            }
            if (offset.centerx < buffer) {
                hpos = "left";
                pos.l = "30%";
            } else if (offset.centerx > windowSize.width - buffer) {
                hpos = "right";
                pos.l = null;
                pos.r = "30%";
            }
            if (offset.centery < buffer) {
                vpos = "top";
                pos.b = null;
                pos.t = "100%";
            }

            if (elem.data('tooltip-position')) {
                const position = elem.data('tooltip-position');
                switch (position) {
                    case "bottom":
                        vpos = "bottom";
                        pos = {
                            l: "50%",
                            r: null,
                            t: null,
                            b: "100%",
                        };
                        break;
                    case "top":
                        vpos = "top";
                        pos = {
                            l: "50%",
                            r: null,
                            t: "100%",
                            b: null,
                        };
                        break;
                }
            }

            if (pos.l) style += "left: " + pos.l + ";";
            if (pos.r) style += "right: " + pos.r + ";";
            if (pos.t) style += "top: " + pos.t + ";";
            if (pos.b) style += "bottom: " + pos.b + ";";
        } else if (Boolean(elem.data('tooltip-outline'))) {
            const rect = elem[0].getBoundingClientRect()
            const center = {x: rect.left + rect.width / 2, y: rect.top + rect.height / 2}
            const bordersize = 30 // approx height of the tooltip.

            yp = windowSize.isMobile ? my : center.y
            //
            hpos = mx < windowSize.width / 3 ? "left" : (mx > (windowSize.width * 2) / 3 ? "right" : "center");
            vpos = yp < windowSize.height / 2 ? "top" : "bottom";
            if (windowSize.isDesktop) {
                vpos = rect.top < bordersize
                    ? "top"
                    : rect.bottom > windowSize.height - bordersize
                        ? "bottom"
                        : my >= rect.top + rect.height / 2
                            ? "bottom"
                            : "top";
            }

            style += "left: " + center.x + "px;"
            style += "top: " + (vpos === "top" ? rect.bottom : rect.top) + "px;"
        } else {
            if (mx && my) {
                style += "left:" + Math.round(mx) + "px;";
                style += "top:" + Math.round(my) + "px;";
            } else {
                style += "left:" + offset.centerx + "px;";
                style += "top:" + Math.round(offset.top - pOffset.scrollTop) + "px;";
            }
            //
            xp = mx;
            yp = windowSize.isMobile ? my : offset.top + pOffset.top + (offset.height / 2);
            //
            hpos =
                xp < windowSize.width / 3
                    ? "left"
                    : mx > (windowSize.width * 2) / 3
                        ? "right"
                        : "center";
            vpos = yp < windowSize.height / 2 ? "top" : "bottom";
            if (windowSize.isDesktop) {
                vpos = my >= offset.top + pOffset.top + (offset.height / 2) ? "top" : "bottom";
            }
        }
        //
        var html = "";
        html += `<div class="tooltip ${elem.data('tooltip-class') || ''}" data-vpos="${vpos}" data-hpos="${hpos}" style="${style}" data-fixed>`;
        html = html.replace('data-fixed', isFixed ? 'data-fixed="' + isFixed + '"' : '');
        html += ' <div class="tooltip-inner">' + str + "</div>";
        html += "</div>";
        $(isInline ? elem : document.body).append(html);
    };

    jQuery.fn.setTooltip = function () {
        var isFixed = Boolean($(this).data('tooltip-fixed'));
        var isInline = Boolean($(this).data('tooltip-inline'));
        if (isFixed) {
            openTooltip($(this), 0, 0, isFixed, isInline);
            return this;
        }

        $(this).on("mouseleave.tooltips blur.tooltips", function (e) {
            clearTimeout(window.tooltipTi);
            window.tooltipTi = -1;
            closeTooltip();
        });

        $(this).on("mouseenter.tooltips focus.tooltips", function (e) {
            if ($(this).data('tooltip-disabled') || windowSize.isMobile) {
                return
            }
            var elem = $(this);
            var mx = e.clientX;
            var my = e.clientY;
            clearTimeout(window.tooltipTi);
            window.tooltipTi = -1;
            window.tooltipTi = setTimeout(function () {
                openTooltip(elem, mx, my, isFixed, isInline);
            }, window.tooltipDelay);
        });

        $(this).on("click.tooltips", function (e) {
            if ($(this).data('tooltip-disabled')) {
                return
            }
            if (windowSize.isMobile) {
                if ($(this).data('tooltip-mobile-callback')) {
                    $(this).data('tooltip-mobile-callback')($(this))
                    return this
                }
                var mx = e.clientX;
                var my = e.clientY;
                var elem = $(this);
                clearTimeout(window.tooltipTi);
                window.tooltipTi = -1;
                window.tooltipTi = setTimeout(function () {
                    openTooltip(elem, mx, my, isFixed, isInline);
                }, window.tooltipDelay);
            }
        });
        return this;
    };
    jQuery.fn.unsetTooltip = function() {
        $(this).off("mouseleave.tooltips mouseenter.tooltips focus.tooltips blur.tooltips click.tooltips")
    }

    setTooltips();
}
